import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sim-card-1"><path d="M9.5 16.5V12.5H14.5V16.5H9.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M4 2.75C4 2.33579 4.33579 2 4.75 2H14.25C14.4489 2 14.6397 2.07902 14.7803 2.21967L19.7803 7.21967C19.921 7.36032 20 7.55109 20 7.75V21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25V2.75ZM8.75 11C8.33579 11 8 11.3358 8 11.75V17.25C8 17.6642 8.33579 18 8.75 18H15.25C15.6642 18 16 17.6642 16 17.25V11.75C16 11.3358 15.6642 11 15.25 11H8.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSimCard1;
